{
  "en": {
    "quiz": {
      "correctAnswers": "{count} correct | {count} correct",
      "finish": "Finish",
      "incorrectAnswers": "{count} incorrect | {count} incorrect",
      "next": "Next",
      "resultsTitle": "Quiz Results",
      "step": "Step {current} of {total}",
      "tryAgain": "Try Again"
    }
  }
}
